import React, { useEffect, useRef, useState } from 'react'
import { useIntl } from 'react-intl';
import { Form, Input, Button } from 'Components';
import Select, { components } from 'react-select';
import { NotificationManager } from 'Components/Notifications';
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CryptoJS from 'crypto-js';
import { useDispatch, useSelector } from 'react-redux';
import { getListFtp, updateFtp, clearRedux, deleteFtp } from 'Redux/actions'
import './ftpForm.scss'

// Styles for the first Select
const customStyles = {
    control: (provided, state) => ({
        ...provided,
        border: state.isFocused ? '1px solid #009dea' : '',
        boxShadow: state.isFocused ? "0 0 8px #88daf8" : '',
        '&:hover': {
            border: '1px solid #009dea',
        },
    }),
};

// Configuration of inputs
const configInputsFormFTP = {
    required: true,
    titleStyles: 'ftp-label',
}

export const FtpForm = (props) => {

    const { value, validate, errorMessage } = props;
    const { ftp , setFtp} = value;
    const {validFtp, setValidFtp} = validate;

    const { messages } = useIntl();

    const dataInitial = {
        host: '',
        hostTemp: '',
        username: '',
        password: '',
        type: 'ftp',
        port: null,
        basePath: ''
    }

    // Option by Select Add new FTPol
    const options = [
        {
            value: messages['formFtp_newAdd'],
            label: messages['formFtp_newAdd']
        }
    ]

    const optionFtp = [
        { value: 'ftp', label: 'FTP' },
        { value: 'sftp', label: 'SFTP' }
    ]

    const dispatch = useDispatch();

    const [ftpSelect, setFtpSelect] = useState(null);
    const [typeFtp, setTypeFtp] = useState(optionFtp[0]);
    const [dataForm, setDataForm] = useState(dataInitial)
    const [isOpenForm, setIsOpenForm] = useState(false)
    const [isUpDate, setIsUpDate] = useState(false)
    const registerFtp = useRef(null);

    const {listFtp,updateFtpData,isDeleteFtp} = useSelector(state => state.reportsSetupModal)


    useEffect(() => {
        dispatch(getListFtp())
        return () => {
            setDataForm(dataInitial)
            setFtpSelect(null)
            setFtp({})
        }
    }, [])


    //Create the object for options the first Select
    listFtp?.items?.map(item => {
        options.push({
            value: item.host,
            label: item.host
        })
    })

    useEffect(() => {
        if(listFtp && ftp?.length > 0){
            setFtpSelect(options.find(option => option.value === ftp))
            loadFormValue(ftp)
        }
    }, [listFtp])



    useEffect(() => {
        if(dataForm.host.length > 0){
            setFtp(dataForm.host);
            setValidFtp(false);
        }else{
            if(ftp.length > 0){
                setFtp(ftp);
            }else{
                setFtp({});
            }
        }
    }, [dataForm])


    // Respond to the Delete FTP
    useEffect(() => {
        if (isDeleteFtp) {
            NotificationManager.success(
                messages['formFtp_successDelete'],
                messages["success"],
                3000,
                null,
                null,
                "success"
            )

            dispatch(getListFtp())
            setDataForm(dataInitial)
        }
        dispatch(clearRedux("REPORTS_MAIN_SCHEDULE", { isDeleteFtp: null }))
    }, [isDeleteFtp])


    // Respond to the Update and create FTP
    useEffect(() => {
        if (updateFtpData) {
            if (updateFtpData.error) {
                setDataForm(dataInitial)
                setFtpSelect(null)
                setFtp('')
                handlerInput('','host');

            } else {
                NotificationManager.success(
                    messages['formFtp_success'],
                    messages["success"],
                    3000,
                    null,
                    null,
                    "success"
                )
                setDataForm(dataInitial)
                setFtpSelect(null)
                dispatch(getListFtp())
                dispatch(clearRedux("REPORTS_MAIN_SCHEDULE", { updateFtpData: null }))
            }
        }
    }, [updateFtpData])


    const handlerInput = (newValue, property) => {
        setDataForm({
            ...dataForm,
            [property]: newValue
        })
    };

    const loadFormValue = (data) => {

        const resp = listFtp?.items.filter(item => item.host === data);

        if(resp.length > 0) {
            const { host, username, password, type, port, basePath, id } = resp[0];

            setTypeFtp(optionFtp.find(item => item.value === type))

            setDataForm({
                id: id,
                host: host,
                username: username,
                password: CryptoJS.AES.decrypt(password, 'gpstrackit').toString(CryptoJS.enc.Utf8),
                type: type,
                port: port || null,
                basePath: basePath
            })
        }else{
            setFtpSelect(null)
        }
    }

    const handleEdit = (value) => {
        setIsUpDate(true)
        setIsOpenForm(true)
        loadFormValue(value);
    };

    //Component for options the first Select
    const Option = (props) => {
        const { value, label, onEdit } = props
        return (
            <div className='ftpForm-options'>
                <components.Control {...props}>
                    <span onClick={() => { setIsOpenForm(false) }} style={{ flexGrow: 1 }}>{label}</span>
                    {value !== messages['formFtp_newAdd'] &&
                        <IconButton size="small" onClick={() => onEdit(value)} style={{ color: 'black' }}>
                            <EditIcon />
                        </IconButton>
                    }
                </components.Control>
            </div>
        );
    };

    return (
        <Form
            noSubmit
            ref={registerFtp}
            onSubmit={()=> {
                dataForm.host = dataForm.hostTemp;
                const valid = Object.values(dataForm).every(item => (`${item}`.trim().length > 0))
                return valid
            }}
            onValidSubmit={()=> {
                setIsOpenForm(false)
                dispatch(updateFtp({
                    ...dataForm,
                    password: CryptoJS.AES.encrypt(dataForm.password, 'gpstrackit').toString(),
                    messages
                }))
            }}
        >
            <section className='ftpForm-form'>
                <div className={'large'}>
                    <label className='ftp-label'>{messages['formFtp_ftpServer']}</label>
                    <span className="text-danger"> *</span>
                    <Select
                        {...props}
                        className="react-select-container"
                        placeholder={messages['formFtp_Label']}
                        classNamePrefix="react-select"
                        defaultValue={dataForm.host}
                        value={ftpSelect}
                        {...configInputsFormFTP}
                        onChange={(e) => {
                            if (e?.value) {
                                setFtpSelect(options.find(item => item.value === e?.value))

                                if (e?.value === messages['formFtp_newAdd']) {
                                    dataInitial.port = '21'
                                    setDataForm(dataInitial)
                                    setIsUpDate(false)
                                } else {
                                    loadFormValue(e?.value)
                                }

                            } else {
                                setIsOpenForm(true)
                            }
                        }}
                        options={options}
                        closeMenuOnSelect={true}
                        components={{
                            Option: (props) => <Option {...props} onEdit={handleEdit} />,
                        }}
                        styles={customStyles}
                    />
                    {validFtp && <small className="text-danger" style={{ paddingTop: 5 }}>{errorMessage}</small>}
                </div>
                {
                    (ftpSelect?.value === messages['formFtp_newAdd'] || isOpenForm) &&

                    <>
                        <Input
                            {...configInputsFormFTP}
                            type={'text'}
                            label={messages['formFtp_host']}
                            requiredMessage={messages['required_field']}
                            value={dataForm.hostTemp}
                            placeholder={messages['formFtp_host']}
                            onChange={newValue => {
                                handlerInput(newValue, "hostTemp")
                            }}
                        />
                        <div>
                            <label className='ftp-label'>{messages['formFtp_protocol']}</label>
                            <span className="text-danger"> *</span>
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                {...configInputsFormFTP}
                                value={typeFtp}
                                styles={customStyles}
                                options={optionFtp}
                                onChange={e => {
                                    setTypeFtp(e)
                                    dataForm.port = e.value === 'ftp' ? '21' : '22';
                                    dataInitial.port = dataForm.port;
                                    handlerInput(e.value, "type")
                                }}
                            />
                        </div>
                        <Input
                            {...configInputsFormFTP}
                            type={'text'}
                            label={messages['formFtp_userName']}
                            placeholder={messages['formFtp_userName']}
                            requiredMessage={messages['required_field']}
                            value={dataForm.username}
                            onChange={newValue => {
                                handlerInput(newValue, "username")
                            }}
                        />
                        <Input
                            {...configInputsFormFTP}
                            type={'password'}
                            label={messages['formFtp_password']}
                            placeholder={'*******'}
                            requiredMessage={messages['required_field']}
                            value={dataForm.password}
                            onChange={newValue => {
                                handlerInput(newValue, "password")
                            }}
                        />
                        <Input
                            titleStyles={'ftp-label'}
                            maxLength={9}
                            type={'number'}
                            label={messages['formFtp_port']}
                            placeholder={messages['formFtp_port']}
                            requiredMessage={messages['required_field']}
                            value={dataForm.port}
                            onChange={newValue => {
                                handlerInput(newValue !== "" ? parseInt(newValue) : null, "port")
                            }}
                        />
                        <Input
                            {...configInputsFormFTP}
                            type={'text'}
                            label={messages['formFtp_basePath']}
                            placeholder={messages['formFtp_basePath']}
                            requiredMessage={messages['required_field']}
                            value={dataForm.basePath}
                            onChange={newValue => {
                                handlerInput(newValue, "basePath")
                            }}
                        />
                        <div className='ftpForm-form__btn large'>
                            <Button
                                className="btn-cancel btn-block btn-sm custom-btn-cancel"
                                onClick={e => {
                                    e.preventDefault();
                                    if (isUpDate) {
                                        dispatch(deleteFtp({ host: dataForm.host, messages }))
                                    }

                                    if (dataForm.host === '' || !isUpDate) {
                                        setDataForm(dataInitial)
                                        setFtpSelect(null)
                                        setIsUpDate( false)
                                        setIsOpenForm(false)
                                    } else {
                                        setFtpSelect(ftpSelect)
                                        setIsUpDate( !isUpDate)
                                    }
                                }}
                            >
                                {isUpDate ?
                                    messages['formFtp_delete'] :
                                    messages['formFtp_cancel']
                                }
                            </Button>
                            <Button
                                className="btn-blue btn-block btn-sm"
                                onClick={e => {
                                    e.preventDefault();
                                    registerFtp.current.submit();
                                }}
                            >
                                {isUpDate ?
                                    messages['formFtp_saveChanges'] :
                                    messages['formFtp_saveFtpServer']
                                }
                            </Button>
                        </div>
                    </>

                }
            </section>
        </Form>
    )
}
